import {
	ClaimSolutionEnum,
	ClaimStatusEnum,
	ClaimTypeEnum,
} from "Infrastructure/Api/Api";
import { z } from "zod";

export const getOrderCreateClaimSchema = () => {
	return z.object({
		orderId: z.number(),
		status: z.nativeEnum(ClaimStatusEnum),
		type: z.nativeEnum(ClaimTypeEnum),
		fee: z.number().nullish(),
		description: z.string().nullish(),
		finalSolution: z.nativeEnum(ClaimSolutionEnum).nullish(),
		dateNextAction: z.string().nullish(),
		dateResolved: z.string().nullish(),
	});
};

export type OrderCreateClaimFormModel = z.infer<
	ReturnType<typeof getOrderCreateClaimSchema>
>;
